<template>
  <WebView :src="srcReal" :height="height" @loadStarted="loadStarted" @loadFinished="loadFinished" />
</template>

<script>

import env from '@/helpers/env'
import url from '@/helpers/url'

export default {
  props: {
    src: {
      type: String
    },
    initialScale: {
      type: String,
      default: '1'
    },
    maxScale: {
      type: String,
      default: '1'
    },
    backgroundColor: {
      type: String,
      default: 'white'
    },
    autoHeight: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      height: 'auto'
    }
  },
  computed: {
    cssFonts () {
      return `

@font-face {
  font-family: Inter;
  font-weight: 400;
  src: url('fonts/Inter-Regular.woff2') format('woff2');
}

@font-face {
  font-family: Inter;
  font-weight: 500;
  src: url('fonts/Inter-Medium.woff2') format('woff2');
}

@font-face {
  font-family: Inter;
  font-weight: 600;
  src: url('fonts/Inter-SemiBold.woff2') format('woff2');
}

@font-face {
  font-family: Inter;
  font-weight: 700;
  src: url('fonts/Inter-Bold.woff2') format('woff2');
}

`
    },
    cssRules () {
      return `

.web-view,
.web-view * {
  padding: 0;
  margin: 0;
  line-height: 150%;
}

.web-view,
body.web-view  {
  font-family: Inter, OpenSans Regular, Helvetica;
  font-size: 16px;
  color: #3b3b3b;
  background-color: ` + this.backgroundColor + `;
  overflow: ` + (this.userScalable ? `auto` : `hidden`) + `;
  height: 100%;
}

.web-view h1,
.web-view h2,
.web-view h3,
.web-view h4,
.web-view h5,
.web-view h6 {
  font-family: Inter, Roboto Condensed, Helvetica;
  font-size: 22px;
  font-weight: 600;
  margin: 30px 0 0 0;
}

.web-view a,
.web-view a:active,
.web-view a:visited {
  color: #004e9e;
}

.web-view p {
  margin: 15px 0 0 0;
}

.web-view :first-child {
  margin-top: 0;
}

.web-view ul,
.web-view ol {
  margin: 15px 0 0 0;
  padding: 0 0 0 30px;
}

.web-view li {
  margin: 15px 0 0 0;
}

`
    },
    srcReal () {
      if (env.platform === 'web') {
        return `<style>` + this.cssRules + `</style>
<div class="web-view">` + this.src + `</div>`
      } else {
        return `<!DOCTYPE html>
<html>
  <head>
    <meta name="viewport"content="width=device-width, initial-scale=` + this.initialScale + `, maximum-scale=` + this.maxScale + `, user-scalable=` + (this.userScalable ? 'yes' : 'no') + `">
    <style>` + this.cssFonts + this.cssRules + `</style>
  </head>
  <body class="web-view">` + this.src + `</body>
</html>`
      }
    },
    userScalable () {
      return this.initialScale < this.maxScale
    }
  },
  watch: {
    src: {
      immediate: true,
      handler () {
        this.loadFinished()
      }
    }
  },
  methods: {
    loadStarted (event) {
      if (event && event.url && event.url.match(/^https?:\/\//)) {
        event.object.stopLoading()

        url.open(event.url)
      }
    },
    loadFinished (event) {
      if (this.autoHeight && event && env.isNative) {
        let code = 'document.body.clientHeight'
        let onReceiveValue = (result) => {
          this.height = parseInt(result)
        }

        if (env.platform === 'ios' && event.object) {
          event.object.ios.evaluateJavaScriptCompletionHandler(code, onReceiveValue)
        }
        else if (env.platform === 'android' && event.object) {
          event.object.android.evaluateJavascript(code, new android.webkit.ValueCallback({onReceiveValue})) // eslint-disable-line
        }
      }
    }
  }
}

</script>